import React from "react";

// Images
import project1 from "../assets/web1.png"
import goodcooking from "../assets/2.jpg"
import devilsmok from "../assets/1.jpg"
import pro2 from "../assets/web2.png"
import SahanPortfolio from "../assets/Sahan portfolio.jpg"
import pro4 from "../assets/web5.png"
import PasanPortfolio from "../assets/pasan portfolio.jpg"
import Animatedlogin from "../assets/Animated Login.jpg"


const Portfolio = () =>{
    return(
        <div class=" py-6 max-w mx-auto" id="portfolio">

            <div class=" mx-auto px-4 md:px-8 max-w-[1240px]">

                {/* Portfolio intro */}
                <div class=" mb-4 flex items-center justify-between gap-8">

                    <div class=" flex flex-col gap-4">

                        <h2 class=" text-2xl lg:text-3xl text-white">
                            My 
                            <span >
                                Portfolio
                            </span>

                        </h2>
                        <p className=" text-gray-500">
                            These are my latest projects for diferent clients.
                        </p>

                    </div>

                </div>



                {/* portfolio */}
                <div class=" grid grid-cols-2 gap-4 sm:grid-cols-3 md:gap-6 xl:gap-8">

                    {/* project 01 good cooking times */}
                    
                    <div className=" transform transition-transform duration-300 hover:scale-110  overflow-hidden
                                shadow-lg shadow-[#040c16] group rounded-md flex justify-center
                                items-center  bg-cover relative">
                    
                    
                        <a href="/" 
                            className=" group h-48 overflow-hidden rounded-lg shadow-lg md:h-80">

                                <img 
                                src={goodcooking} 
                                alt="" 
                                className=" h-full w-full object-cover object-center transition
                                        duration-200 group-hover:scale-110"/>

                        </a>

                        <div className=" opacity-0 group-hover:opacity-90 bg-gray-500 absolute inset-0 flex flex-col
                                        justify-center text-center ">
                            <span className=" text-2xl font-bold text-white tracking-wider">
                            Good Cooking Times - food blog
                            </span>

                            <div className=" pt-8 text-center">
                                <a href="/">
                                    <button className=" text-center rounded-lg px-4 py-3 m-2
                                                         bg-white text-gray-700 font-bold text-lg">
                                        Live unavalible
                                    </button>
                                </a>

                            </div>

                        </div>




                    </div>



                    

                    {/* project 02 */}
                    



                    <div className=" transform transition-transform duration-300 hover:scale-110  overflow-hidden
                                shadow-lg shadow-[#040c16] group rounded-md flex justify-center
                                items-center  bg-cover relative">
                    
                    
                        <a href="/" 
                            className=" group h-48 overflow-hidden rounded-lg shadow-lg md:h-80">

                                <img 
                                src={PasanPortfolio} 
                                alt="" 
                                className=" h-full w-full object-cover object-center transition
                                        duration-200 group-hover:scale-110"/>

                        </a>

                        <div className=" opacity-0 group-hover:opacity-90 bg-gray-500 absolute inset-0 flex flex-col
                                        justify-center text-center ">
                            <span className=" text-2xl font-bold text-white tracking-wider">
                            Pasan Hewawitharane - Portfolio site
                            </span>

                            <div className=" pt-8 text-center">
                                <a href="/">
                                    <button className=" text-center rounded-lg px-4 py-3 m-2
                                                         bg-white text-gray-700 font-bold text-lg">
                                        Live unavalible
                                    </button>
                                </a>

                            </div>

                        </div>




                    </div>

                    {/* project 03 devil smok */}
                    <div className=" transform transition-transform duration-300 hover:scale-110  overflow-hidden
                                shadow-lg shadow-[#040c16] group rounded-md flex justify-center
                                items-center  bg-cover relative">
                    
                    
                        <a href="dev-devilsmok.pantheonsite.io" 
                            className=" group h-48 overflow-hidden rounded-lg shadow-lg md:h-80">

                                <img 
                                src={devilsmok} 
                                alt="" 
                                className=" h-full w-full object-cover object-center transition
                                        duration-200 group-hover:scale-110"/>

                        </a>

                        <div className=" opacity-0 group-hover:opacity-90 bg-gray-500 absolute inset-0 flex flex-col
                                        justify-center text-center ">
                            <span className=" text-2xl font-bold text-white tracking-wider">
                            DevilSmok - Portfolio site
                            </span>

                            <div className=" pt-8 text-center">
                                <a href="http://dev-devilsmok.pantheonsite.io"
                                target="_blank">
                                    <button className=" text-center rounded-lg px-4 py-3 m-2
                                                         bg-white text-gray-700 font-bold text-lg">
                                        Live
                                    </button>
                                </a>

                            </div>

                        </div>




                    </div>

                    {/* project 04 */}
                    <div className=" transform transition-transform duration-300 hover:scale-110  overflow-hidden
                                shadow-lg shadow-[#040c16] group rounded-md flex justify-center
                                items-center  bg-cover relative">
                    
                    
                        <a href="https://thilinaabey.github.io/animated-login-page/"
                            target="_blank"
                            className=" group h-48 overflow-hidden rounded-lg shadow-lg md:h-80">

                                <img 
                                src={Animatedlogin} 
                                alt="" 
                                className=" h-full w-full object-cover object-center transition
                                        duration-200 group-hover:scale-110"/>

                        </a>

                        <div className=" opacity-0 group-hover:opacity-90 bg-gray-500 absolute inset-0 flex flex-col
                                        justify-center text-center ">
                            <span className=" text-2xl font-bold text-white tracking-wider">
                            Animeted Login Page
                            </span>

                            <div className=" pt-8 text-center">
                                <a href="https://thilinaabey.github.io/animated-login-page/"
                                target="_blank">

                                    <button className=" text-center rounded-lg px-4 py-3 m-2
                                                         bg-white text-gray-700 font-bold text-lg">
                                        Live 
                                    </button>
                                </a>

                            </div>

                        </div>




                    </div>

                    {/* project 05 */}
                    <div className=" transform transition-transform duration-300 hover:scale-110  overflow-hidden
                                shadow-lg shadow-[#040c16] group rounded-md flex justify-center
                                items-center  bg-cover relative">
                    
                    
                        <a href="/" 
                            className=" group h-48 overflow-hidden rounded-lg shadow-lg md:h-80">

                                <img 
                                src={SahanPortfolio} 
                                alt="" 
                                className=" h-full w-full object-cover object-center transition
                                        duration-200 group-hover:scale-110"/>

                        </a>

                        <div className=" opacity-0 group-hover:opacity-90 bg-gray-500 absolute inset-0 flex flex-col
                                        justify-center text-center ">
                            <span className=" text-2xl font-bold text-white tracking-wider">
                            Smart Bouquet
                            </span>

                            <div className=" pt-8 text-center">
                                <a href="/">
                                    <button className=" text-center rounded-lg px-4 py-3 m-2
                                                         bg-white text-gray-700 font-bold text-lg">
                                        Live unavalible
                                    </button>
                                </a>

                            </div>

                        </div>




                    </div>

                    
                    {/* project 06 */}
                    <div className=" transform transition-transform duration-300 hover:scale-110  overflow-hidden
                                shadow-lg shadow-[#040c16] group rounded-md flex justify-center
                                items-center  bg-cover relative">
                    
                    
                        <a href="/" 
                            className=" group h-48 overflow-hidden rounded-lg shadow-lg md:h-80">

                                <img 
                                src={pro2} 
                                alt="" 
                                className=" h-full w-full object-cover object-center transition
                                        duration-200 group-hover:scale-110"/>

                        </a>

                        <div className=" opacity-0 group-hover:opacity-90 bg-gray-500 absolute inset-0 flex flex-col
                                        justify-center text-center ">
                            <span className=" text-2xl font-bold text-white tracking-wider">
                            Elegent Nails
                            </span>

                            <div className=" pt-8 text-center">
                                <a href="/">
                                    <button className=" text-center rounded-lg px-4 py-3 m-2
                                                         bg-white text-gray-700 font-bold text-lg">
                                        Live unavalible
                                    </button>
                                </a>

                            </div>

                        </div>




                    </div>
                    






                </div>




            </div>
            
        </div>
    )
}


export default Portfolio